import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/scroll.vue
var o = {
	name: "DtIconScroll",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--scroll"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Scroll",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M.94 1.44A1.5 1.5 0 0 1 2 1h6.5A1.5 1.5 0 0 1 10 2.5V8h1a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 10 11H4a1.5 1.5 0 0 1-1.5-1.5v-5H1A.5.5 0 0 1 .5 4V2.5c0-.398.158-.78.44-1.06ZM3.5 9.5v-7a1.5 1.5 0 0 0-.086-.5H8.5a.5.5 0 0 1 .5.5V8H5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0Zm-1-7v1h-1v-1a.5.5 0 1 1 1 0Zm7.854 7.354A.5.5 0 0 1 10 10H5.414a1.5 1.5 0 0 0 .086-.5V9h5v.5a.5.5 0 0 1-.146.354Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=scroll.js.map